import { UserRoles, UserRolesTranslations } from "../types/user.types";

export const getAvailableRoles = (
  currentUserRole: UserRoles
): { key: string; value: string }[] => {
  return Object.entries(UserRoles)
    .filter(([key]) => isNaN(Number(key)))
    .filter(([_, value]) => {
      if (currentUserRole === UserRoles.SYSTEM_ADMIN) {
        return true;
      }
      if (currentUserRole === UserRoles.CLIENT_ADMIN) {
        return (
          value === UserRoles.PRIMARY_USER || value === UserRoles.INVITED_USER
        );
      }
      return false;
    })
    .map(([key, value]) => ({
      key: value.toString(),
      value: UserRolesTranslations[value as UserRoles] || key,
    }));
};
